import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import PageHeader from "../../Layout/PageHeader";
import Tab from "../../Shared/Tab/Tab";
import DynamicDetailGrid from "../../Components/Grid/DynamicDetailGrid";
import { getClientDetails } from "./service/client.service";
import Loader from "../../Components/GlobalLoader/Loader";

export default function ClientDetails() {
  const navigation = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [client, setClient] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const pageName = "Client";

  useEffect(() => {
    if (id) {
      getClientDetails(id).then((response) => {
        setClient(response.data ?? null);
        setLoading(false);
      });
    }
  }, [id]);

  const clientDetails = client
    ? {
        basicInformation: [
          { label: "Client Code", value: client.code },
          { label: "Client Name", value: `${client?.name}` },
          { label: "Phone", value: client.contact_phone || "-" },
          { label: "Email", value: client.contact_email || "-" },
          { label: "Address 1", value: client.address_line_1 || "-" },
          { label: "Address 2", value: client.address_line_2 || "-" },
          { label: "City", value: client.city || "-" },
          { label: "State/Province", value: client.state_province || "-" },
          { label: "Zip/Postal Code", value: client.postal_code || "-" },
          { label: "Country", value: client.country?.name || "-" },
        ],
      }
    : null;

    const clientDetailsData = {
      additionalChanges: [
        { label: 'Bill Code', value: '123987' },
        { label: 'Type', value: 'Automatic Billing' },
        { label: 'Description', value: 'Storage' },
        { label: 'Rate', value: '$25.00' },
        {
          label: 'Status',
          value: client && client.status === true ? 'Active' : 'Inactive'
        }
      ],
      inboundSettings: [
        { label: 'Reference 1', value: '-' },
        { label: 'Reference 2', value: '-' },
        { label: 'Check in', value: 'Yes' },
        { label: 'Onloading', value: 'Yes' },
        { label: 'Receiving', value: 'Yes' },
        { label: 'Purchase Order', value: 'Yes' },
        { label: 'Cross Dock', value: 'Yes' },
        { label: 'Allow Backorder', value: 'Yes' },
        { label: 'Receipt Email', value: 'Yes' },
      ],
      outboundSettings: [
        { label: 'Reference 1', value: '-' },
        { label: 'Reference 2', value: '-' },
        { label: 'Reference 3', value: '-' },
        { label: 'Reference 4', value: '-' },
        { label: 'Allow Backorder', value: 'Yes' },
        { label: 'Shipment Emails', value: 'Yes' },
      ]
    }
  
  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: client ? renderBasicInfo() : "Loading...",
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Additional Changes",
      content: client ? renderAdditionalChanges(client) : "Loading...",
      visibility: true,
      status: true,
      disabled: true
    },
    {
      order: 2,
      label: "Settings",
      content: client ? renderSettings(client) : "Loading...",
      visibility: true,
      status: true,
      disabled: true
    },
  ];


  const handleEditAction = () => {
    navigation(`/account/client/overview/edit/${id}`);
  };

  function renderBasicInfo() {
    return (
      <div>
        <div id="tab-1">
          <DynamicDetailGrid
            customClassName="my-2"
            isExpandable={false}
            columns={3}
            data={clientDetails?.basicInformation || []}
          />
        </div>
      </div>
    );
  }

  function renderAdditionalChanges(client: any) {
    return (
      <div>
        <div id="tab-2" className="">
          <DynamicDetailGrid customClassName="my-2" isExpandable={false} columns={3} data={clientDetailsData.additionalChanges} />
        </div>
      </div>
    );
  }

  function renderSettings(client: any) {
    return (
      <div>
        <div id="tab-3" className="">
          <div className="my-2 bg-white rounded">
            <div className="px-4 pt-2 col-12 border-bottom border-light-subtle">
              <h6>Inbound Setting</h6>
            </div>
            <div className="px-4 pt-2 col-12">
              <h6>ASN Field</h6>
            </div>
            <DynamicDetailGrid isExpandable={false} columns={3} data={clientDetailsData.inboundSettings} customClassName="mx-4" />
          </div>
          <div className="my-2 bg-white rounded">
            <div className="px-4 pt-2 col-12 border-bottom border-light-subtle">
              <h6>Outbound Field</h6>
            </div>
            <DynamicDetailGrid isExpandable={false} columns={3} data={clientDetailsData.outboundSettings} customClassName="mx-4" />
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <PageHeader listUrl="/account/client/overview/grid-view" gridUrl="/account/client/overview/grid-view" name={pageName} viewType={true} />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">
        {pageName} ({client && client.code})
      </h5>
      <div className="mt-2">
        <Tab tabs={tabs} listLength={1} />
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton className="sph-btn me-4" handleClick={handleEditAction}>
            Edit
          </FormButton>
        </div>
      </div>
    </>
  );
}
